export default __webpack_public_path__ + "static/media/download-doc.039504fa.svg";